import { Routes } from '@angular/router';
import {HomeComponent} from './home/home.component'
import { RuleComponent } from './rule/rule.component';
import { GameComponent } from './game/game.component';
import { GameplayComponent } from './gameplay/gameplay.component';
export const routes: Routes = [
    {path: "",component:HomeComponent},
    {path: "rule", component:RuleComponent},
    {path: "game", component:GameComponent},
    {path: "gameplay", component:GameplayComponent}
];
